export default "__VITE_ASSET__D1tPorT2__"